import { Component } from '@angular/core';
import {PlannerComponent} from "../../components/planner/planner.component";

@Component({
  selector: 'app-planner-page',
  standalone: true,
  imports: [PlannerComponent],
  templateUrl: './planner-page.component.html',
  styleUrl: './planner-page.component.css'
})
export class PlannerPageComponent {

}
